import React, { FC } from 'react';

import { Stack, Box, Link, HStack } from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

import { StackedHeader } from 'components/DataDisplay';
import { IconTypes } from 'components/Icons';
import { Modal } from 'components/Overlay';
import { toTitleCase } from 'utils/string';

interface Props {
  cveDetails: Record<string, any>;
  isOpen: boolean;
  onClose: () => void;
}

export const CVEReferencesModal: FC<Props> = props => {
  const { cveDetails, isOpen, onClose } = props;

  const renderCVEHeader = () =>
    (cveDetails?.cvss_score ?? cveDetails?.cvss_v3?.score
      ? 'CVSS V3 Score: ' +
        Number(cveDetails?.cvss_score ?? cveDetails?.cvss_v3?.score).toFixed(
          1,
        ) +
        ' '
      : '') +
    ', Severity: ' +
    toTitleCase(cveDetails?.severity);

  const header = (
    <StackedHeader
      upper={cveDetails?.vulnerability_id ?? cveDetails?.cve_id}
      lower={renderCVEHeader()}
      type={IconTypes.Vulnerabilities}
      /*selectedTab === VulnerabilityViewByTabs.CVE
          ? IconTypes.Vulnerabilities
          : IconTypes.Packages*/
      color={customTheme.colors?.[cveDetails?.severity?.toLowerCase()]}
      useCustomColor
    />
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      header={header}
      body={
        <Box maxH={96} overflow="auto" w="full">
          <Stack spacing={3} pl={3} flex={1}>
            {map(cveDetails?.references, (o, index) => (
              <HStack key={index + '-cve-reference'} pl={4} w="full">
                <Box color="primary">
                  <Link href={o} target="_blank">
                    {o}
                  </Link>
                </Box>
              </HStack>
            ))}
          </Stack>
        </Box>
      }
    />
  );
};
